<ion-content>
  <div class="modal-box">
    <order *ngIf="basketItem" [basketItem]="basketItem" (itemChangedOutput)="itemChanged($event)" (addOutput)="addToBasket()" (cancelOutput)="modalCtrl.dismiss(false)"></order>
  </div>
</ion-content>